import _ from 'underscore';
import { getLogger } from './logging/logger';
import fetchData from './util/fetch';

const logger = getLogger('Api');

export default class Api {
	constructor() {
		logger.log('[constructor]');

		this.baseUrl = window.location.origin;
	}

	get(url, options) {
		logger.log('[get]', url);
		return this.send('GET', url, null, options);
	}

	put(url, data, options) {
		logger.log('[put]', url, data);
		return this.send('PUT', url, data, options);
	}

	post(url, data, options) {
		logger.log('[post]', url, data);
		return this.send('POST', url, data, options);
	}

	send(method, url, data, options) {
		logger.log('[send]', method, url, data);

		if (url.indexOf('//') < 0) {
			url = this.baseUrl + url;
		}

		try {
			if (data && !_.isString(data)) {
				data = JSON.stringify(data);
			}
		} catch (e) {
			console.warn('[Invalid data]', { data });
		}

		return fetchData(url, {
			method,
			body: data,
			...options,
		});
	}
}
